import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface CustomerUser {
  id: string
  email: string
  name: string
  customerId: string | null
}

interface CustomerAuthState {
  user: CustomerUser | null
  accessToken: string | null
  refreshToken: string | null
  isImpersonation: boolean
  setTokens: (args: { accessToken: string; refreshToken?: string | null; user: CustomerUser; isImpersonation?: boolean }) => void
  logout: () => void
}

export const useCustomerAuthStore = create<CustomerAuthState>()(
  persist(
    (set) => ({
      user: null,
      accessToken: null,
      refreshToken: null,
      isImpersonation: false,
      setTokens: ({ accessToken, refreshToken, user, isImpersonation }) => {
        set({ accessToken, refreshToken: refreshToken ?? null, user, isImpersonation: !!isImpersonation })
      },
      logout: () => {
        set({ accessToken: null, refreshToken: null, user: null, isImpersonation: false })
      },
    }),
    {
      name: 'customer-auth-storage',
      partialize: (state) => ({
        user: state.user,
        accessToken: state.accessToken,
        refreshToken: state.refreshToken,
        isImpersonation: state.isImpersonation,
      }),
    },
  ),
)
